window.__LOG_FS_KEYS = window.__LOG_FS_KEYS || false
export const environment = {
  CONFIG_API_BASE_URL: window._env_.CONFIG_API_BASE_URL,
  CONFIG_API_BASE_URL_PHP: window._env_.CONFIG_API_BASE_URL_PHP,
  CONFIG_API_BASE_URL_PHP_V2: window._env_.CONFIG_API_BASE_URL_PHP_V2,
  CONFIG_OAUTH_BASE_URL: window._env_.CONFIG_OAUTH_BASE_URL,
  CONFIG_OAUTH_CLIENT_ID: window._env_.CONFIG_OAUTH_CLIENT_ID,
  CONFIG_OAUTH_REDIRECT_URI: window._env_.CONFIG_OAUTH_REDIRECT_URI,
  CONFIG_API_BASE_URL_DRIVE_API_GATEWAY: window._env_.CONFIG_API_BASE_URL_DRIVE_API_GATEWAY,
  DASHBOARD_BASE_URL: window._env_.DASHBOARD_BASE_URL,
  MIXPANEL_TOKEN: window._env_.MIXPANEL_TOKEN,
  MIXPANEL_DEBUG: window._env_.MIXPANEL_DEBUG,
  MIXPANEL_HOST: window._env_.MIXPANEL_HOST,
  IS_DEV: process.env.NODE_ENV === 'development'
}
